import { DomainSerializer } from "src/app/global/serializables/domain.serializer";
import { ArquivoComprovantePix } from "../domain/arquivo-comprovante-pix.model";

export class ArquivoComprovantePixSerializer extends DomainSerializer<ArquivoComprovantePix> {}